import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { travelTicketRepository } from '@webapp/modules/expense/data-access/repositories/TravelTicketRepository'
import messages from './messages'

export type AttachableTravelTicketSelectValue = {
  id: number
  displayLabel: string
}

export interface IAttachableTravelTicketSelectProps extends IAsyncSelectProps<AttachableTravelTicketSelectValue> {
  userId: number
}

export const AttachableTravelTicketSelect = ({
  userId,
  ...props
}: IAttachableTravelTicketSelectProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IAttachableTravelTicketSelectProps['loadOptions'] = (
    inputValue,
    pagination,
    callback
  ) => {
    travelTicketRepository
      .listAttachable({
        userId,
        search: inputValue,
        page: pagination.page,
      })
      .then((res) => {
        callback({
          options: res.data.map((ticket) => ({
            id: ticket.id,
            displayLabel: intl.formatMessage(messages.travelTicketLabel, {
              id: ticket.id,
              purpose: ticket.purpose,
            }),
          })),
          pagination: {
            hasMore: res.pagination
              ? res.pagination.page < res.pagination.numPages
              : false,
            page: pagination.page + 1,
          },
        })
      })
      .catch(() => {
        callback({
          options: [],
          pagination: { hasMore: false, page: 1 },
        })
      })
  }

  return (
    <AsyncSelect<AttachableTravelTicketSelectValue>
      cacheOptions={true}
      defaultOptions={true}
      clearCacheOnMenuClose
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(option) => option.displayLabel}
      getOptionValue={(option) => option.id.toString()}
      {...props}
    />
  )
}
